import { createSlice } from "@reduxjs/toolkit";
import { deleteQuickreply, getQuickreplyAllData, insertQuickreply } from "./QuickreplyThunk";

const initialState = {
  insertQuickreplySuccess: null,
  insertQuickreplyError: null,
  insertQuickreplyLoading: false, // Use a default `false` state

  getQuickreplySuccess: null,
  getQuickreplyError: null,
  getQuickreplyLoading: false, // Use a default `false` state

  deleteQuickreplySuccess: null,
  deleteQuickreplyError: null,
  deleteQuickreplyLoading: false, // Use a default `false` state
};

const QuickreplySlice = createSlice({
  name: "quickreply",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle insertQuickreply actions
      .addCase(insertQuickreply.pending, (state) => {
        state.insertQuickreplyLoading = true;
        state.insertQuickreplyError = null; // Reset error
        state.insertQuickreplySuccess = null;
      })
      .addCase(insertQuickreply.fulfilled, (state, action) => {
        state.insertQuickreplySuccess = action.payload;
        state.insertQuickreplyLoading = false;
      })
      .addCase(insertQuickreply.rejected, (state, action) => {
        state.insertQuickreplyError = action.payload;
        state.insertQuickreplyLoading = false;
      })

      // Handle getQuickreplyAllData actions
      .addCase(getQuickreplyAllData.pending, (state) => {
        state.getQuickreplyLoading = true;
        state.getQuickreplyError = null; // Reset error
        state.getQuickreplySuccess = null;
      })
      .addCase(getQuickreplyAllData.fulfilled, (state, action) => {
        console.log(action.payload,"---actionactionaction")
        state.getQuickreplySuccess = action.payload;
        state.getQuickreplyLoading = false;
      })
      .addCase(getQuickreplyAllData.rejected, (state, action) => {
        state.getQuickreplyError = action.payload;
        state.getQuickreplyLoading = false;
      })
      .addCase(deleteQuickreply.pending, (state) => {
        state.deleteQuickreplyLoading = true;
        state.deleteQuickreplyError = null; // Reset error
        state.deleteQuickreplySuccess = null;
      })
      .addCase(deleteQuickreply.fulfilled, (state, action) => {
        console.log(action.payload,"---actionactionaction")
        state.deleteQuickreplySuccess = action.payload;
        state.deleteQuickreplyLoading = false;
      })
      .addCase(deleteQuickreply.rejected, (state, action) => {
        state.deleteQuickreplyError = action.payload;
        state.deleteQuickreplyLoading = false;
      })
  },
});

export default QuickreplySlice.reducer;
